import { render, staticRenderFns } from "./my-documents.page.vue?vue&type=template&id=2e637192&"
import script from "./my-documents.page.vue?vue&type=script&lang=ts&"
export * from "./my-documents.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports